import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.ATF, StringBundle.BTF],
  strings: ['AVOD_DP_redeem_gift_card_or_promotion'] as const,
}
